angular.module('webApp', [
  'webApp.controllers',
  'webApp.services',
  'webApp.filters',

  'ui.router',

  'ngSanitize',
  'ngTouch',
  'ngAnimate',

  'ace.apiService',
  'ace.helperService',
  'ace.generalFilters',
  'ace.errorService',
  // 'ace.cart',

  'hj.gsapifyRouter',
  'hj.carousel',
  'hj.uiSrefFastclick',
  'hj.columnify',
  'hj.customCursor',

  'LocalStorageModule',
  'angular-images-loaded',
  'angular-loading-bar',
  'duScroll',
  // 'iso-3166-country-codes',
]);

angular.module('webApp').constant('appConfig', appConfig);

// angular.module('webApp').value('duScrollEasing', easing.easeInOutQuint)
angular.module('webApp').value('duScrollDuration', 800);
angular.module('webApp').value('duScrollOffset', 75);

angular
  .module('webApp')
  .config(function (
    $stateProvider,
    $locationProvider,
    $urlRouterProvider,
    $urlMatcherFactoryProvider,
    $httpProvider,
    $provide,
    $sceDelegateProvider,
    $sceProvider,
    $anchorScrollProvider,
    $uiViewScrollProvider,
    gsapifyRouterProvider,
    cfpLoadingBarProvider
  ) {
    // Disable security to allow untrusted urls...
    // $sceProvider.enabled(false)

    // ... or whitelist them
    $sceDelegateProvider.resourceUrlWhitelist([
      'self',
      'https://*.s3.amazonaws.com/**',
      'https://*.youtube.com/**',
      'http://*.fokus.io/**',
      'http://*.vimeo.com/**',
      '//*.embedly.com/**',
      '//*.cdninstagram.com/**',
    ]);

    // Overrides

    // Kill default ng-src
    // $provide.decorator('ngSrcDirective', ['$delegate', '$sniffer',
    //     function($delegate, $sniffer) {
    //         var directive = $delegate[0].compile = function(element, attrs) {}
    //         return $delegate
    //     }
    // ])

    // Kill ui-router scoll into view
    // $uiViewScrollProvider.useAnchorScroll()
    // $anchorScrollProvider.disableAutoScrolling()

    // Send data as form vars by default
    // $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'

    // Routing

    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/404');
    // $urlRouterProvider.otherwise(($injector, $location) => {
    //   window.location.href = '/404'
    // })
    $urlMatcherFactoryProvider.strictMode(false);

    // Remove trailing slash
    $urlRouterProvider.rule(function ($injector, $location) {
      var path = $location.url();

      if (path[path.length - 1] === '/') {
        return path.replace(/\/$/, '');
      }

      if (path.indexOf('/?') > 0) {
        return path.replace('/?', '?');
      }

      return false;
    });

    // Providers

    // cfpLoadingBarProvider.latencyThreshold = 0
    cfpLoadingBarProvider.includeSpinner = false;
    cfpLoadingBarProvider.includeBar = true;

    // Transitions

    gsapifyRouterProvider.defaults = {
      enter: 'fadeDelayed',
      leave: 'fade',
    };

    gsapifyRouterProvider.transition('fade', {
      duration: 0.4,
      css: {
        opacity: 0,
      },
    });

    gsapifyRouterProvider.transition('fadeDelayed', {
      duration: 0.4,
      delay: 0.4,
      css: {
        opacity: 0,
      },
    });

    gsapifyRouterProvider.transition('noneDelayed', {
      duration: 0,
      delay: 1.5,
      css: {
        opacity: 0,
      },
    });

    gsapifyRouterProvider.transition('slideAboveOut', {
      duration: 0.5,
      delay: 1,
      ease: 'Quint.easeOut',
      css: {
        y: '-100%',
      },
    });

    gsapifyRouterProvider.transition('slideAboveIn', {
      duration: 0.5,
      delay: 0,
      ease: 'Quint.easeIn',
      css: {
        y: '-100%',
      },
    });

    gsapifyRouterProvider.transition('slideBelow', {
      duration: 1.5,
      delay: 0,
      ease: 'Quint.easeInOut',
      css: {
        y: '100%',
      },
    });

    // States

    var states = [];

    states.push({
      name: '404',
      url: '/404',
      views: {
        main: {
          templateUrl: '/templates/404.html',
          controller: /*@ngInject*/ function ($rootScope, $state, $timeout) {
            $rootScope.statusCode = 404;

            $timeout(function () {
              $state.go('main.home');
            }, 2000);
          },
        },
      },
    });

    states.push({
      name: 'main',
      abstract: true,
      resolve: {
        metadata: /*@ngInject*/ function ($rootScope, ApiService) {
          return ApiService.metadata().then(function (metadata) {
            $rootScope.metadata = metadata;

            $rootScope.pageDescription = metadata.description;

            return metadata;
          });
        },
        work: /*@ngInject*/ function (ApiService) {
          return ApiService.entitySearch({
            q: 'schema:project',
            sort: '-sort.publishedAt<number>',
            children: 1,
          }).then(function (work) {
            return work.rows;
          });
        },
      },
      views: {
        main: {},
        menu: {
          templateUrl: '/templates/main-menu.html',
        },
      },
    });

    states.push({
      name: 'main.home',
      url: '/',
      resolve: {
        selectWork: /*@ngInject*/ function (ApiService) {
          return ApiService.entitySearchOne({
            q: 'schema:selectWork',
            children: 1,
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/home.html',
          controller: /*@ngInject*/ function (
            $rootScope,
            $scope,
            $state,
            HelperService,
            selectWork
          ) {
            var ctrl = this;

            $rootScope.pageTitle = null;

            ctrl.selectWork = selectWork.fields.projects;

            $scope.$on('carousel:changeSuccess', function (e, i) {
              ctrl.currentIndex = i;
            });

            ctrl.nextProject = function () {
              $scope.$broadcast('carousel:next');
            };

            ctrl.startIdx = ctrl.currentIndex = HelperService.randomInt(
              0,
              ctrl.selectWork.length
            );

            $rootScope.prevCategory = null;
          },
          controllerAs: 'ctrl',
        },
      },
    });

    states.push({
      name: 'main.work',
      url: '/work?category',
      reloadOnSearch: false,
      resolve: {
        categories: /*@ngInject*/ function (ApiService) {
          return ApiService.taxonomy('category');
        },
        types: /*@ngInject*/ function (ApiService) {
          return ApiService.taxonomy('type');
        },
      },
      views: {
        content: {
          templateUrl: '/templates/work.html',
          controller: /*@ngInject*/ function (
            $rootScope,
            $window,
            $scope,
            $state,
            $document,
            $location,
            $timeout,
            HelperService,
            work,
            categories
          ) {
            var ctrl = this;

            $rootScope.pageTitle = 'Work';

            ctrl.work = work;

            var categoryArray = [];

            ctrl.work.forEach(function (project) {
              var category = project.fields.category.terms[0];

              if (categoryArray.indexOf(category.slug) === -1) {
                categoryArray.push(category.slug);
              }
            });

            ctrl.categories = categories.terms.filter(function (category) {
              return categoryArray.indexOf(category.slug) !== -1;
            });

            var filterWork = function () {
              var categorySlug = $location.search().category;

              if (!categorySlug) {
                ctrl.work = work;

                ctrl.activeCategory = {
                  slug: null,
                  title: 'All Work',
                };
              } else {
                ctrl.work = work.filter(function (project) {
                  return project.fields.category.terms[0].slug === categorySlug;
                });

                ctrl.activeCategory = ctrl.categories.filter(function (
                  category
                ) {
                  return category.slug === categorySlug;
                })[0];
              }

              $rootScope.prevCategory = ctrl.activeCategory.slug;
            };

            $scope.$on('$locationChangeSuccess', function () {
              var scrollY = $window.scrollY;

              if (scrollY > 0) {
                $document.scrollTo(0, 0, 300);
              }

              $timeout(
                function () {
                  ctrl.filtering = true;

                  $timeout(function () {
                    filterWork();

                    $timeout(function () {
                      ctrl.filtering = false;
                    }, 100);
                  }, 400);
                },
                scrollY > 0 ? 300 : 0
              );
            });

            filterWork();

            ctrl.showNav = false;
            $timeout(function () {
              ctrl.showNav = true;
            }, 800);
          },
          controllerAs: 'ctrl',
        },
      },
    });

    states.push({
      name: 'main.project',
      url: '/work/{project:[A-Za-z0-9_-]{1,200}}?category&i',
      reloadOnSearch: false,
      resolve: {
        project: /*@ngInject*/ function ($stateParams, ApiService) {
          return ApiService.entitySearchOne({
            q: 'schema:project slug:"' + $stateParams.project + '"',
            children: 1,
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/project.html',
          controller: /*@ngInject*/ function (
            $rootScope,
            $scope,
            $state,
            $stateParams,
            $location,
            HelperService,
            work,
            project
          ) {
            var ctrl = this;

            $rootScope.pageTitle = project.title;

            ctrl.project = project;

            ctrl.assets = HelperService.group(ctrl.project.fields.assets);

            ctrl.startIdx = Number($location.search().i || 0);

            ctrl.currentIndex = ctrl.startIdx;

            var socialImageUrl = HelperService.thumbnailSrc(
              ctrl.project.fields.assets[ctrl.startIdx].thumbnail,
              'w:1500;q:90'
            );

            $rootScope.ogImage = $rootScope.twitterImage = socialImageUrl;

            $scope.$on('carousel:changeSuccess', function (e, i, args) {
              ctrl.currentIndex = i;

              $location.search({
                i: i,
              });
            });

            if ($stateParams.category) {
              ctrl.categorySlug = $stateParams.category;

              work = work.filter(function (project) {
                return (
                  project.fields.category.terms[0].slug ===
                  $stateParams.category
                );
              });
            }

            ctrl.adjacent = HelperService.getAdjacent(work, project);
          },
          controllerAs: 'ctrl',
        },
      },
    });

    states.push({
      name: 'main.info',
      url: '/information',
      resolve: {
        info: /*@ngInject*/ function (ApiService) {
          return ApiService.entitySearchOne({
            q: 'schema:information',
            children: 1,
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/info.html',
          controller: /*@ngInject*/ function (
            $rootScope,
            $state,
            HelperService,
            info
          ) {
            var ctrl = this;

            $rootScope.pageTitle = 'Information';

            ctrl.info = info;

            $rootScope.prevCategory = null;
          },
          controllerAs: 'ctrl',
        },
      },
    });

    states.push({
      name: 'main.book',
      url: '/book/{book:[a-zA-Z0-9_-]{1,200}}',
      resolve: {
        book: /*@ngInject*/ function ($stateParams, ApiService) {
          return ApiService.entitySearchOne({
            q: 'schema:book AND slug:"' + $stateParams.book + '"',
            children: 2,
          });
        },
      },
      views: {
        content: {
          templateUrl: '/templates/book.html',
          controller: /*@ngInject*/ function (
            $rootScope,
            $state,
            HelperService,
            book
          ) {
            var ctrl = this;

            $rootScope.pageTitle = book.title;

            ctrl.book = book;

            ctrl.variants = book.fields.variants.map(function (variant) {
              return {
                id: variant.id,
                title: book.title + ' — ' + variant.title,
                price: variant.fields.price,
                metadata: {
                  product: {
                    id: book.id,
                    title: book.title,
                  },
                  variant: {
                    id: variant.id,
                    title: variant.title,
                  },
                },
                thumbnail: HelperService.thumbnailSrc(
                  book.thumbnail,
                  'w:200;h:300;q:90;g:center'
                ),
                slug: variant.slug,
              };
            });

            ctrl.emailSubject = encodeURIComponent('Website order');

            ctrl.emailBody = encodeURIComponent(
              'Hi Katya,\n' +
                '\n' +
                'I would like to place an order for the following:\n' +
                '\n' +
                '[item] [quantity] [price]\n' +
                '\n' +
                'My details for the invoice:\n' +
                '\n' +
                '[name]\n' +
                '[address]\n' +
                '[phone]\n' +
                '\n' +
                'Many thanks,\n'
            );

            $rootScope.prevCategory = null;
          },
          controllerAs: 'ctrl',
        },
      },
    });

    states.forEach(function (state) {
      $stateProvider.state(state.name, state);
    });
  });
